<div class="contenedor">
  <iframe
    aria-label="Te regalan la suscripción a la revista Magisnet"
    frameborder="0"
    style="
      height: 102vh;
     
      border: none;
      padding-top: min(var(--form-cont-space-top), 20px);
      padding-left: min(var(--form-cont-space-left), 20px);
      padding-right: min(var(--form-cont-space-right), 20px);
      padding-bottom: min(var(--form-cont-space-bottom), 20px);
    "
    src="https://forms.zohopublic.eu/thecampus/form/SuscripcinMagisterioAcadmica/formperma/HuTv5-ChqbUg5UFKwUE4oPvwyA3Bubppt5oOJLZ1Eg4"
  ></iframe>
</div>

<div class="sm-video">
  <video
    id="video_background"
    loop
    muted
    autoplay
    oncanplay="this.play()"
    onloadedmetadata="this.muted = true"
  >
    <source src="assets/video/thecampus2.mp4" type="video/mp4" />
  </video>
</div>
